interface IButton {
  primary?: boolean;
  children: React.ReactNode;
  modifier?: string;
  link: string;
}

const Button = ({ primary, modifier, children, link, ...rest }: IButton) => {
  const baseStyle = `font-black py-2 px-4 border rounded`;
  const styles = primary
    ? `bg-h-gold text-h-navy border-h-gold hover:opacity-80`
    : `bg-h-navy text-h-gold border-h-gold hover:opacity-80`;

  return (
    <>
      <a href={link}>
        <button
          type="button"
          className={`${baseStyle} ${styles} ${modifier ?? ``}`}
          {...rest}
        >
          {children}
        </button>
      </a>
    </>
  );
};

export default Button;
